export default __webpack_public_path__ + "static/media/Strugani 2.004bec8b.jpg";